import { useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { toast } from "sonner";

pdfjs.GlobalWorkerOptions.workerSrc =
  `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const options = {
  wasmUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/wasm/`,
  standardFontDataUrl:
    `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
  cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
};

const PdfViewer = ({
  preview,
  zipMeta,
  analytics,
  onDocumentLoadSuccess,
  numPages,
  scale,
  setScale,
}) => {
  const toastId = "pdf-load";

  /* -------------------- PDF LOAD FEEDBACK -------------------- */

  useEffect(() => {
    toast.loading("Loading PDF…", { id: toastId });

    return () => {
      toast.dismiss(toastId);
    };
  }, [preview.filePath]);

  const handlePdfLoadSuccess = (data) => {
    toast.success("PDF loaded successfully", { id: toastId });
    onDocumentLoadSuccess(data);
  };

  const handlePdfLoadError = () => {
    toast.error("Failed to load PDF", { id: toastId });
  };

  /* -------------------- RENDER -------------------- */

  return (
    <div className="pdf-viewer">
      <div className="pdf-toolbar">
        <button onClick={() => setScale((s) => Math.max(s - 0.1, 0.6))}>
          −
        </button>
        <span>{Math.round(scale * 100)}%</span>
        <button onClick={() => setScale((s) => Math.min(s + 0.1, 1.5))}>
          +
        </button>
      </div>

      <div className="pdf-canvas">
        <Document
          file={preview.data}
          options={options}
          onLoadSuccess={handlePdfLoadSuccess}
          onLoadError={handlePdfLoadError}
        >
          {Array.from(new Array(numPages), (_, index) => (
            <div key={`page_${index + 1}`} className="pdf-page">
              <Page
                pageNumber={index + 1}
                scale={scale}
                onRenderSuccess={() => {
                  analytics.track({
                    event_type: "pdf_page_rendered",
                    zip_id: zipMeta.zip_id,
                    creator_id: zipMeta.creator_id,
                    verified: zipMeta.verified,
                    file_path: preview.filePath,
                    metadata: { page: index + 1 },
                  });
                }}
              />
            </div>
          ))}
        </Document>
      </div>
    </div>
  );
};

export default PdfViewer;